import React from "react";
import "@babel/polyfill";
import collapsableComponent from "./collapsable/Collapsable";
import FormSubmitFeedbackComponent from "./formSubmitFeedback/FormSubmitFeedback";
import SelectBoxComponent from "./select-box/SelectBox";
import * as helperMethods from "./helpers";
import createComponent from "./hoc/createComponent";
import anchorComponent from "./anchor/Anchor";
import CheckoutLoadingComponent from "./loading/CheckoutLoading";
import LoadingComponent from "./loading/Loading";
import ButtonComponent from "./anchor/Button";
import ContentRendererComponent from "./contentRenderer/ContentRenderer";

export const Anchor = anchorComponent;
export const Button = ButtonComponent;
export const Collapsable = collapsableComponent;
export const FormSubmitFeedback = FormSubmitFeedbackComponent;
export const CheckoutLoading = CheckoutLoadingComponent;
export const Loading = LoadingComponent;
export const SelectBox = SelectBoxComponent;
export const helpers = helperMethods;
export const hoc = { createComponent };
export const ContentRenderer = ContentRendererComponent;
